/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/ReferralSource/Content/Referrals/Referral/Source/Search/SearchBar/Content/Empty"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral400}
 text="No matches found"
/>
{children}
</React.Fragment>)
}